import React from 'react';

import {
  IconSettings,
  PageHeader as SalesforcePageHeader
} from '@salesforce/design-system-react';

import {MalibuIcon} from '@heroku/react-malibu'

const PageHeader = props => {

  function render() {
    return(
        <IconSettings iconPath="/assets/icons">
          <SalesforcePageHeader
          details={details}
          label="Heroku Application"
          title={props.app.name}
          icon={<MalibuIcon name="app-28" size={32} />}
          variant="record-home"
          />
        </IconSettings>
    )
  }

  const details = [
			{
				label: 'Owner',
        content: <a href={userPath()}>{props.app.owner.email}</a>,
			},
			{ label: 'Pipeline', content: props.pipeline.name },
			{
				label: 'Stage',
				content: props.pipeline.stage,
			},
			{
				label: 'Region',
				content: props.app.region.name
			},
	];

  function userPath() {
    return `/users/${props.app.owner.id}`;
  }

  return render()
}

export default PageHeader
